"use strict";
'use es6'; // cleanup nulls to grab default strings from record, we might need to
// TODO update the endpoints to return empty strings instead of nulls

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitNameAndExtension = exports.cleanObject = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var cleanObject = function cleanObject(item) {
  var values = (0, _extends2.default)({}, item);
  Object.keys(values).forEach(function (key) {
    if (values[key] == null) {
      delete values[key];
    }
  });
  return values;
}; // Copied over from FileManagerUI https://git.hubteam.com/HubSpot/FileManagerUI/blob/master/FileManagerCore/static/js/utils/file.js#L35


exports.cleanObject = cleanObject;

var splitNameAndExtension = function splitNameAndExtension(file) {
  var name = file.name;
  /* eslint-disable no-useless-escape */

  var matches = name.match(/(.*)\.([^\.]+)$/);
  /* eslint-enable no-useless-escape */

  if (!matches) {
    return {
      extension: '',
      name: name
    };
  }

  return {
    name: matches[1],
    extension: matches[2].toLowerCase()
  };
};

exports.splitNameAndExtension = splitNameAndExtension;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/formatters.js
// module id = 59
// module chunks = 209 210 211 212 213